import(/* webpackMode: "eager" */ "/var/www/html/prod/src/app/global-error.tsx")